import { apiCall, API_CONFIG } from './api';

export const notificationApi = {
  // Create notification que
  createQue: async (queData) => {
    try {
      const formData = new FormData();
      formData.append('title', queData.title);
      formData.append('bodyText', queData.bodyText);
      formData.append('userData', JSON.stringify(queData.userData || []));

      if (queData.image instanceof File) {
        formData.append('image', queData.image);
      }

      formData.append('country', queData.country || '');
      formData.append('language', queData.language || '');

      const data = await apiCall(API_CONFIG.ENDPOINTS.NOTIFICATION_QUE_CREATE, {
        method: 'POST',
        body: formData,
      });

      if (data.success) {
        return {
          success: true,
          data: data.data,
          msg: data.msg || 'Notification que created successfully'
        };
      } else {
        return {
          success: false,
          error: data.msg || 'Failed to create notification que',
          errorCode: data.errorCode
        };
      }
    } catch (error) {
      console.error('Error creating notification que:', error);
      throw error;
    }
  },

  // Fetch all notification ques
  fetchAllNotificationQues: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();

      if (params.type) queryParams.append('type', params.type);
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);

      const endpoint = `${API_CONFIG.ENDPOINTS.NOTIFICATION_QUE_FETCHALL}?${queryParams.toString()}`;

      const response = await apiCall(endpoint);
      return response;
    } catch (error) {
      console.error('Error fetching notification Ques:', error);
      throw error;
    }
  },

  fetchNotificationQueById: async (queId) => {
    try {
      const endpoint = `${API_CONFIG.ENDPOINTS.NOTIFICATION_QUE_FETCHALL}/${queId}`;
      const response = await apiCall(endpoint);
      return response;
    } catch (error) {
      console.error('Error fetching WhatsApp Que:', error);
      throw error;
    }
  },
};